import { Button, CircularProgress, Container, createStyles, Grid, makeStyles, Paper, TextField, Theme, Typography } from '@material-ui/core';
import React, { FormEvent, useState } from 'react';
import { Helmet } from 'react-helmet';
import Navbar from './../components/Navbar';
import Header from './../components/Header';
import { IRecibospago } from './interfaces';
import { AXIOS_OPTIONS, MAIN_API } from '../utils/constants';
import Axios from 'axios';
import Recibo from '../components/Recibo';
import useQuery from './../hooks/useQuery';
import { handleAxiosError } from '../utils/functions';

const useStyles = makeStyles((theme: Theme) => createStyles({
    testSuccess: {
        backgroundColor: theme.palette.success.main,
        padding: 15,
        color: "white",
        borderRadius: 10
    },
    testInvalid: {
        backgroundColor: theme.palette.error.main,
        padding: 15,
        color: "white",
        borderRadius: 10
    }
}))

const ReceiptAuthentication = () => {
    const queryData = useQuery();
    const [receiptCode, setReceiptCode] = useState(queryData.get("code") || "");
    const [receiptData, setReceiptData] = useState<IRecibospago | boolean | undefined>();
    const [loading, setLoading] = useState(false);
    const classes = useStyles();

    const verifyReceipt = async (e: FormEvent) => {
        e.preventDefault();
        const api = `${MAIN_API}/recibos/autenticar`;
        const data = { selloElectronico: receiptCode }
        setLoading(true);
        try {
            const res = await Axios.post(api, data, AXIOS_OPTIONS);
            const reciboValido: boolean = res.data.reciboValido;
            if (reciboValido){
                const recibo: IRecibospago = res.data.recibo;
                setReceiptData(recibo);
            } else {
                setReceiptData(false);
            }
        } catch (error){
            await handleAxiosError(error);
        }
        setLoading(false);
    }

    return (
        <section>
            <Helmet>
                <title>InfoISSET | Autenticar recibo de pago</title>
            </Helmet>
            <Navbar />
            <Container>
                <Header />
                <Typography>
                    Utilice esta herramienta para verificar la <strong>autenticidad</strong> de un <strong>recibo de pago</strong>.
                </Typography>
                <Paper style={{minHeight: "50vh", display: "flex", justifyContent: "center", alignItems: "center", padding: 15, marginTop: 15}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <form onSubmit={verifyReceipt}>
                                <TextField 
                                fullWidth
                                value={receiptCode}
                                onChange={e => setReceiptCode(e.target.value)}
                                required
                                label="Código de su recibo"
                                variant="outlined"
                                />
                                <Button type="submit" variant="contained" color="primary" style={{marginTop: 15, width: "100%"}}>Verificar</Button>
                            </form>
                        </Grid>
                        <Grid item xs={12} sm={6} style={{display: "flex", alignItems: "center", justifyContent: "center"}}>
                            {loading ? <CircularProgress /> : null}
                            {!receiptData && receiptData === undefined && !loading ? 
                            <Typography style={{textAlign: "center"}}>
                                Ingrese su código de recibo
                            </Typography>
                            : null}
                            {!receiptData && receiptData !== undefined && !loading ? 
                            <Typography style={{textAlign: "center"}} className={classes.testInvalid}>
                                El código ingresado no es válido
                            </Typography>
                            : null}
                            {receiptData && typeof receiptData === "object" && !loading ? 
                            <React.Fragment>
                                <Typography component="div" style={{textAlign: "center"}} className={classes.testSuccess}>
                                    El código ingresado pertenece a un recibo válido. Consúltelo haciendo click <Recibo recibo={receiptData} title="aquí" />.
                                </Typography>
                            </React.Fragment>
                            : null}
                        </Grid>
                    </Grid>
                </Paper>
            </Container>
        </section>
    );
};

export default ReceiptAuthentication;